export default __webpack_public_path__ + "static/media/Montserrat-Light.9a01c2f5.ttf";